import { Chip } from "@mui/material";

const formatters = {
  Status: (value) => (
    <Chip
      label={value}
      style={{
        backgroundColor:
          value === "Paused"
            ? "#ffffcc"
            : value === "Active"
            ? "#ccffff"
            : value === "Inactive"
            ? "#ffccff"
            : value === "Closed" || value === "Deleted"
            ? "#ffcccc"
            : "#ccffcc",
        color:
          value === "Closed" || value === "Deleted"
            ? "red"
            : value === "Active"
            ? "green"
            : value === "Inactive"
            ? "gray"
            : "black",
        fontWeight: "bold",
      }}
    />
  ),
  isVerified: (value) => (
    <Chip
      label={value}
      style={{
        backgroundColor: value === "Verified" ? "#ccffcc" : "#ffcccc",
        color: value === "Verified" ? "green" : "red",
        fontWeight: "bold",
      }}
    />
  ),
  status: (value) => (
    <Chip
      variant="outlined"
      label={value}
      style={{
        backgroundColor: "",
        color: "blue",
        fontWeight: "bold",
      }}
    />
  ),
  "Request Type": (value) => (
    <Chip
      label={value}
      style={{
        backgroundColor:
          value === "POST"
            ? "#e0f7fa"
            : value === "GET"
            ? "#e8f5e9"
            : value === "DELETE"
            ? "#ffebee"
            : "#fff8e1",
        color:
          value === "POST"
            ? "#00796b"
            : value === "GET"
            ? "#388e3c"
            : value === "DELETE"
            ? "#d32f2f"
            : "#f9a825",
        fontWeight: "bold",
      }}
    />
  ),
  "Log Status": (value) => {
    if (!value) return null;

    return (
      <Chip
        label={value}
        style={{
          backgroundColor:
            value === "Success"
              ? "#e0f7fa"
              : value === "Error"
              ? "#ffebee"
              : "#ffffffff",
          color:
            value === "Success"
              ? "#00796b"
              : value === "Error"
              ? "#d32f2f"
              : "#fff8e1",
          fontWeight: "bold",
        }}
      />
    );
  },
};

export default formatters;
